/*
*
* =================================================================================================================

    AKTIVACIA NOVEHO UZIVATELA - zadanie hesla

* =================================================================================================================
*
*/

import React, { useEffect, useState, useRef } from 'react';

import './App.css';
import './styles.css';
import './globals_conditions';
import { ButtonNew, DialogDates, EmptyList, FormError, FormLabel, FormSelect, FormSpace, FormText, FormYesNo, Icon, Line, Loading, ShowError, ShowOK, SuperAdmin, TextInput } from './items';
import { styles } from './styles';
import { Backdrop, Button, FormControlLabel, IconButton, MenuItem, Paper, Radio, RadioGroup, Select, rgbToHex, useMediaQuery } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFrown, faInfoCircle, faLayerGroup, faPerson, faPlusCircle, faUser, faXmark } from '@fortawesome/free-solid-svg-icons';
import { CheckPermission, Debug, GetLanguage, GetPages, IsEmpty, SaveLogin, paswordCheck } from './functions';
import { Today } from './functions_date';
import { sk } from './language_sk';
import { useNavigate, useParams } from 'react-router-dom';


export const UserActivate = (props) => {

    const navigate = useNavigate();
    const logo = require('./react/app/logo_vision.png');

    let radius = global.radius;
    let color = global.themes[0];

    // SYSTEM
    const [isBusy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [language, setLanguage] = useState(0);

    const [showOK, setShowOK] = useState(false);
    const [showError, setShowError] = useState(false);

    // PARAMS
    const [user, setUser] = useState(false);
    const [linkError, setLinkError] = useState(false);
    const [password, setPassword] = useState('');

    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    let { func } = props;
    let params = useParams();
    var running = false;
    var lang = GetLanguage(language);

    const inputRef = useRef(null);

    useEffect(() => {
        if (running == false) {
            db_get();
            running = true;
        }

        return () => {
        };

    }, []);

    const db_get = async () => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'user_uid', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    uid: params.uid
                })
            })

            const json = await response.json();

            if (json.ok > 0) {
                if (json.user == false) {
                    // NENAJDENY UZIVATEL -> CHYBA
                    setLinkError(true);
                } else {
                    setUser(json.user);
                    setLanguage(json.user.language_id);

                    // FOCUS TO TEXTAREA
                    setTimeout(() => {
                        inputRef.current.focus();
                    }, 300);
                }
            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }

    const db_update = async (data) => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'user_activate', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data: data
                })
            })

            const json = await response.json();
            Debug(json);
            setBusy(false);
            if (json.ok > 0) {
                SaveLogin({ token: json.token, expire: 0 });
                setShowOK(true);
            } else {
                setShowError(true);
            }


        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }


    const ShowErrorPress = (value) => {
        setShowError(false);
    }

    const ShowOKPress = () => {
        setShowOK(false);
        navigate('/application');
    }

    const Save = () => {
        setError('');

        if (password == '' || password.length < 8) {
            setError(lang.password_error_len);
        } else {
            let data = {
                id: user.id,
                uid: '',
                activated: true,
                password: password,
            }

            db_update(data);
        }
    }

    return (
        <div style={{ ...styles.Block, height: height, fontFamily: 'roboto', msOverflowStyle: 'none', scrollbarWidth: 'none', backgroundColor: color.desktop_background, backgroundSize: 'cover' }} className='container'>
            <Paper elevation={3} style={{ ...styles.Block, maxWidth: 400, width: '100%', borderRadius: global.radius, paddingTop: 40, paddingBottom: 40 }}>
                {user != false ?
                    <div style={{ ...styles.Block }}>
                        <img src={logo} style={{ width: '100%', height: '100%', maxWidth: 150, maxHeight: 150, objectFit: 'contain' }}></img>
                        <p style={{ ...styles.TextLarge, marginTop: 20 }}>{lang.title_welcome}</p>
                        <div style={{ ...styles.Block, width: 320, marginTop: 40 }}>
                            <p style={{ ...styles.TextTiny, marginBottom: 5 }}>{lang.password_new_account}</p>
                            <TextInput password inputRef={inputRef} theme={props.theme} enabled={true} lang={lang} value={password} label={''} radius={global.radius} func={(txt) => setPassword(txt)} />
                            <div style={{ ...styles.Block, height: 30 }}>
                                {password.length > 0 ?
                                    <p style={{ ...styles.TextTiny, color: paswordCheck(password) == 0 ? color.dark_red : color.black }}>{lang.password_strong}: {lang.passwords[paswordCheck(password)]}</p>
                                    : null}
                            </div>
                        </div>
                        <div style={{ ...styles.Block, marginTop: 40 }}>
                            <div style={{ ...styles.Block, paddingBottom: 20 }}>
                                <FormError theme={0} error={error} small />
                            </div>
                            <Button onClick={() => Save()} style={{ ...styles.ButtonThemed, backgroundColor: color.button_dark }}>{lang.save}</Button>
                        </div>
                    </div>
                    : null}

                {linkError == true ?
                    <div style={{ ...styles.Block }}>
                        <FontAwesomeIcon style={{ height: 32, color: color.dark_red }} icon={faFrown} />
                        <p style={{ ...styles.TextSmall, marginTop: 20 }}>{lang.link_error}</p>
                    </div>
                    : null}
            </Paper>

            {showOK == true ?
                <ShowOK center theme={0} func={ShowOKPress.bind(this)} />
                : null}

            {showError == true ?
                <ShowError center theme={0} text={lang.db_error} sub_text={lang.db_error_text} func={ShowErrorPress.bind(this)} />
                : null}

            {isBusy == true ?
                <Loading center></Loading>
                : null}

        </div>
    );
}
